import {RootState} from "../../store/rootReducer";

export const reviewCardSelector = (state: RootState) => {
    if (state.review.cardId === undefined) {
        return undefined;
    }

    return state.cards[state.review.cardId];
}